import * as React from 'react';
import { useMemo } from 'react';
var SIGNAL_TYPES;
(function (SIGNAL_TYPES) {
    SIGNAL_TYPES[SIGNAL_TYPES["SEND_CHAT_MESSAGE"] = 0] = "SEND_CHAT_MESSAGE";
    SIGNAL_TYPES[SIGNAL_TYPES["RECEIVE_CHAT_MESSAGE"] = 1] = "RECEIVE_CHAT_MESSAGE";
    SIGNAL_TYPES[SIGNAL_TYPES["DELETE_CHAT_MESSAGE"] = 2] = "DELETE_CHAT_MESSAGE";
    SIGNAL_TYPES[SIGNAL_TYPES["RECEIVE_DELETE_CHAT_MESSAGE"] = 3] = "RECEIVE_DELETE_CHAT_MESSAGE";
    SIGNAL_TYPES[SIGNAL_TYPES["RECEIVE_PARTICIPANT"] = 4] = "RECEIVE_PARTICIPANT";
    SIGNAL_TYPES[SIGNAL_TYPES["RECEIVE_PARTICIPANT_STATUS"] = 5] = "RECEIVE_PARTICIPANT_STATUS";
    SIGNAL_TYPES[SIGNAL_TYPES["SEND_REACTION"] = 6] = "SEND_REACTION";
    SIGNAL_TYPES[SIGNAL_TYPES["RECEIVE_REACTION"] = 7] = "RECEIVE_REACTION";
    SIGNAL_TYPES[SIGNAL_TYPES["REQUEST_SOFT_MUTE"] = 8] = "REQUEST_SOFT_MUTE";
    SIGNAL_TYPES[SIGNAL_TYPES["SOFT_MUTE"] = 9] = "SOFT_MUTE";
    SIGNAL_TYPES[SIGNAL_TYPES["SCREENSHARE"] = 10] = "SCREENSHARE";
    SIGNAL_TYPES[SIGNAL_TYPES["JOIN_ERROR"] = 11] = "JOIN_ERROR";
    SIGNAL_TYPES[SIGNAL_TYPES["RECORDER_STOPPED"] = 12] = "RECORDER_STOPPED";
})(SIGNAL_TYPES || (SIGNAL_TYPES = {}));
export var JoinErrorType;
(function (JoinErrorType) {
    JoinErrorType[JoinErrorType["TIMEOUT"] = 0] = "TIMEOUT";
    JoinErrorType[JoinErrorType["FAILED"] = 1] = "FAILED";
})(JoinErrorType || (JoinErrorType = {}));
const api = () => {
    const callbacks = {};
    const send = (type, ...payload) => {
        const callbackArray = callbacks[type] || [];
        callbackArray.forEach((callback) => callback(...payload));
    };
    const receive = (type, callback) => {
        callbacks[type] = callbacks[type] || [];
        callbacks[type].push(callback);
        return () => {
            const callbackIndex = callbacks[type].indexOf(callback);
            callbacks[type] = [...callbacks[type].slice(0, callbackIndex), ...callbacks[type].slice(callbackIndex + 1)];
        };
    };
    return {
        sendChatMessage: (message) => send(SIGNAL_TYPES.SEND_CHAT_MESSAGE, message),
        onSendChatMessage: (callback) => receive(SIGNAL_TYPES.SEND_CHAT_MESSAGE, callback),
        receiveChatMessage: (message) => send(SIGNAL_TYPES.RECEIVE_CHAT_MESSAGE, message),
        onReceiveChatMessage: (callback) => receive(SIGNAL_TYPES.RECEIVE_CHAT_MESSAGE, callback),
        deleteChatMessage: (id) => send(SIGNAL_TYPES.DELETE_CHAT_MESSAGE, id),
        onDeleteChatMessage: (callback) => receive(SIGNAL_TYPES.DELETE_CHAT_MESSAGE, callback),
        receiveDeleteChatMessage: (id) => send(SIGNAL_TYPES.RECEIVE_DELETE_CHAT_MESSAGE, id),
        onReceiveDeleteChatMessage: (callback) => receive(SIGNAL_TYPES.RECEIVE_DELETE_CHAT_MESSAGE, callback),
        recorderStopped: (recording) => send(SIGNAL_TYPES.RECORDER_STOPPED, recording),
        onRecorderStopped: (callback) => receive(SIGNAL_TYPES.RECORDER_STOPPED, callback),
        receiveParticipant: (receivedParticipant) => send(SIGNAL_TYPES.RECEIVE_PARTICIPANT, receivedParticipant),
        onReceiveParticipant: (callback) => receive(SIGNAL_TYPES.RECEIVE_PARTICIPANT, callback),
        receiveParticipantStatus: (receivedParticipantStatus) => send(SIGNAL_TYPES.RECEIVE_PARTICIPANT_STATUS, receivedParticipantStatus),
        onReceiveParticipantStatus: (callback) => receive(SIGNAL_TYPES.RECEIVE_PARTICIPANT_STATUS, callback),
        sendReaction: (reaction) => send(SIGNAL_TYPES.SEND_REACTION, reaction),
        onSendReaction: (callback) => receive(SIGNAL_TYPES.SEND_REACTION, callback),
        receiveReaction: (reaction) => send(SIGNAL_TYPES.RECEIVE_REACTION, reaction),
        onReceiveReaction: (callback) => receive(SIGNAL_TYPES.RECEIVE_REACTION, callback),
        requestSoftMute: (participantId) => send(SIGNAL_TYPES.REQUEST_SOFT_MUTE, { participantId }),
        onRequestSoftMute: (callback) => receive(SIGNAL_TYPES.REQUEST_SOFT_MUTE, callback),
        softMute: (payload) => send(SIGNAL_TYPES.SOFT_MUTE, payload),
        onSoftMute: (callback) => receive(SIGNAL_TYPES.SOFT_MUTE, callback),
        toggleScreenshare: (enabled) => send(SIGNAL_TYPES.SCREENSHARE, enabled),
        onToggleScreenshare: (callback) => receive(SIGNAL_TYPES.SCREENSHARE, callback),
        joinError: (error) => send(SIGNAL_TYPES.JOIN_ERROR, error),
        onJoinError: (callback) => receive(SIGNAL_TYPES.JOIN_ERROR, callback),
    };
};
export const SignalingApiProvider = ({ children }) => {
    const signalingApi = useMemo(api, []);
    return React.createElement(SignalingApiContext.Provider, { value: signalingApi }, children);
};
const SignalingApiContext = React.createContext(null);
export const useSignalingApi = () => React.useContext(SignalingApiContext);
//# sourceMappingURL=signaling-api.js.map